import { useMemo } from 'react';

import { useFiltersContext } from '@/packages/Filters';
import { getLocationIdForMetro } from '@/packages/Filters/shared/utils/geo';

export function useLocationForUndergrounMap(): number {
  const { currentLocation } = useFiltersContext();
  const locationId = useMemo<number>(() => getLocationIdForMetro(currentLocation), [currentLocation]);

  return locationId;
}
